/** Durable HomeVein identity used by application relationships and actor fields. */
export type ApplicationUserId = string & { readonly __applicationUserId: unique symbol };

export function parseApplicationUserId(value: unknown): ApplicationUserId {
  if (typeof value !== 'string' || !value.trim()) {
    throw new Error('Application profile response is missing applicationUserId');
  }

  return value.trim() as ApplicationUserId;
}
